import { useExperienceContent } from '../../../../hooks/use-server-content';
import { ExperienceFragmentModel } from '../../../../services/content-service/content-service.interface';

interface CanonicalTagTopicId {
    topicId: string;
    canonicalTag: string;
}

export interface CanonicalTagTopicProps extends ExperienceFragmentModel {
    canonicalTagTopicIds: CanonicalTagTopicId[];
}

export const useCanonicalTagContent = (): CanonicalTagTopicProps | null => {
    const [content] = useExperienceContent<CanonicalTagTopicProps>(
        'common',
        'canonical-tags',
        'canonicaltags'
    );
    return content;
};
